import script from "./AudienceFooterButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudienceFooterButtons.vue?vue&type=script&setup=true&lang=ts"

import "./AudienceFooterButtons.vue?vue&type=style&index=0&id=4f166b8e&scoped=true&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f166b8e"]])

export default __exports__